var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackQuestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_58)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2001_58",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2001_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 14.8803C5.14536 14.8803 4.95202 14.8336 4.77868 14.7403C4.39868 14.5403 4.16536 14.1403 4.16536 13.7136V12.767C2.15203 12.5603 0.832031 11.0803 0.832031 8.96025V4.96029C0.832031 2.66695 2.37203 1.12695 4.66536 1.12695H11.332C13.6254 1.12695 15.1654 2.66695 15.1654 4.96029V8.96025C15.1654 11.2536 13.6254 12.7936 11.332 12.7936H8.8187L5.97868 14.687C5.78534 14.8137 5.5587 14.8803 5.33203 14.8803ZM4.66536 2.12028C2.94536 2.12028 1.83203 3.23361 1.83203 4.95361V8.95365C1.83203 10.6737 2.94536 11.787 4.66536 11.787C4.9387 11.787 5.16536 12.0137 5.16536 12.287V13.707C5.16536 13.7937 5.2187 13.8337 5.25203 13.8537C5.28537 13.8737 5.35204 13.8937 5.42537 13.847L8.39203 11.8737C8.47203 11.8203 8.57203 11.787 8.67203 11.787H11.3387C13.0587 11.787 14.172 10.6737 14.172 8.95365V4.95361C14.172 3.23361 13.0587 2.12028 11.3387 2.12028H4.66536Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99726 8.07423C7.72393 8.07423 7.49726 7.84757 7.49726 7.57423V7.43423C7.49726 6.66091 8.06393 6.2809 8.27726 6.13423C8.52393 5.96757 8.60393 5.85424 8.60393 5.68091C8.60393 5.34757 8.3306 5.07422 7.99726 5.07422C7.66393 5.07422 7.3906 5.34757 7.3906 5.68091C7.3906 5.95424 7.16393 6.18091 6.8906 6.18091C6.61729 6.18091 6.39062 5.95424 6.39062 5.68091C6.39062 4.79424 7.1106 4.07422 7.99726 4.07422C8.88393 4.07422 9.60393 4.79424 9.60393 5.68091C9.60393 6.44091 9.04393 6.8209 8.83727 6.9609C8.57727 7.13423 8.49726 7.24757 8.49726 7.43423V7.57423C8.49726 7.85423 8.2706 8.07423 7.99726 8.07423Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.73438C7.72 9.73438 7.5 9.50771 7.5 9.23438C7.5 8.96104 7.72667 8.73438 8 8.73438C8.27333 8.73438 8.5 8.96104 8.5 9.23438C8.5 9.50771 8.28 9.73438 8 9.73438Z",
    fill: "#5A5A5A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackQuestionIcon);
export default __webpack_public_path__ + "static/media/feedback-question-icon.3674e31a5a3d2d6323cefde1a36e9b1c.svg";
export { ForwardRef as ReactComponent };